export const setActiveCaseRun = (caseRuns, processId)=>{
    return caseRuns.find((caseRun)=>{
        return caseRun.process_instance_id === processId;
    });
};
